import React from "react";
import logo from "../images/logo.png";
import curvaRodape from "../images/curva-rodape.svg";
import "../css/footer.css";

export default function Footer() {
  return (
    <footer className="main-footer">
      <img src={curvaRodape} alt="Curva rodapé decorativa" className="curva-rodape" />
      <div className="footer-content">
        <img src={logo} alt="Logo casal" className="footer-logo" />
        <p>Com amor Janine e Alan</p>
      </div>
    </footer>
  );
}
